import Vue from 'vue'
import App from './App'
import router from './router'

import 'normalize.css' // 重置样式表
import ElementUI from 'element-ui'
import './../theme/index.css'
import {Toast} from 'vant'
import commonComponent from './components/common/index'

Vue.use(ElementUI)
Vue.use(commonComponent)
Vue.use(Toast)
Vue.prototype.$message = ElementUI.Message
// 阻止启动生产消息
Vue.config.productionTip = false

new Vue ({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js